export default __webpack_public_path__ + "static/media/04_odvoz-dreva.9babf912.jpg";